import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import CalendarView from '@/components/CalendarView';

export default function CalendarPage() {
  const { user } = useAuth();
  const [sendingDigest, setSendingDigest] = useState(false);
  const isAdminOrOwner = ['Administrator', 'Owner'].includes(user?.role);

  const handleSendDigest = async () => {
    setSendingDigest(true);
    try {
      const r = await api.post('/calendar/send-weekly-digest');
      toast.success(`Weekly digest sent to ${r.data.recipient_count} team members`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error sending digest');
    }
    setSendingDigest(false);
  };

  return (
    <div className="space-y-4 animate-fade-in" data-testid="calendar-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-[22px] font-medium tracking-tight">Calendar</h1>
        </div>
        {isAdminOrOwner && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleSendDigest}
            disabled={sendingDigest}
            className="text-xs border-border text-primary hover:text-primary/80 gap-1.5"
            data-testid="send-weekly-digest-btn"
          >
            <Send className="h-3 w-3" />
            {sendingDigest ? 'Sending...' : 'Send Weekly Digest'}
          </Button>
        )}
      </div>
      <CalendarView />
    </div>
  );
}
